// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFileUpload-Container_cls1__EaLSa","cls2":"VeloFileUpload-Container_cls2__OUI3R VeloFileUpload-Container_cls1__EaLSa"};